import type { HangupCallEventPublisher } from '@usecases/hangup-call.usecase';
import { BusIframe } from '@main/bus-layer/bus-iframe';
import type { BusEvent } from '@main/utils/bus-event-promisifier';
import { BusEventsPromisifier } from '@main/utils/bus-event-promisifier';
import { Logger } from '@main/utils/logger';

export class HangupCallPublisher implements HangupCallEventPublisher {
  private logger: Logger;
  constructor() {
    this.logger = new Logger();
  }

  async publish(): Promise<void> {
    const busIframe = await BusIframe.getIframe();

    const busEvent: BusEvent = {
      type: 'DIALER.HANGUP',
    };

    this.logger.info('Publisher: Hangup call', {
      action: 'HangupCall',
    });

    const message = {
      type: 'SCV.VOICE_CALL_ENDED',
      data: {},
    };

    if (window.parent) {
      window.parent.postMessage(message, '*');
    }

    return BusEventsPromisifier.promisifyFireAndForgetEvent({
      target: busIframe,
      event: busEvent,
    });
  }
}
